const config = {
    id: 3,
    name: "文本",
    type: 1,
    module_code: "text",
    icon: "icon-tms-text",
    font_icon: "&#xe6fb;",
    style_type: 1,
    link_type: 0,
    property_data: {
        margin_top: 10,
        margin_right: 10,
        margin_bottom: 10,
        margin_left: 10
    }
};
export default config;